module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"contact_link":"https://www.flow-solutions.com/en/get-started","custom_range":"Custom Range","compare_period":"Compared Period","compare_with":"Compare with","previous_period":"Previous Period"}}')
  delete Component.options._Ctor
}
